import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledAuthorAndDate = styled.div`
  display: flex;
  ${MediaQueries.mbUp} {
    gap: 24px;
    align-items: center;
    justify-content: space-between;
  }
  ${MediaQueries.mbDown} {
    gap: 12px;
    flex-direction: column;
  }

  .author-avatar {
    display: flex;
    flex-shrink: 0;
    margin-right: 0.6em;
    img {
      border: solid 1.5px ${(props: ThemeProps) => props.theme.colors.blue100};
      object-fit: cover;
    }
  }
  .author-content {
    display: inline;
    color: #404040;
    font-size: 14px;
    font-weight: ${(props: ThemeProps) => props.theme.sizes.fwRegular};
    line-height: 1.5;
    span {
      color: #404040;
      a {
        color: #404040;
        text-decoration: none;
      }
      &.reviewer-info {
        a {
          font-weight: bold;
          text-decoration: underline;
        }
        &[data-is-unclickable='true'] {
          a {
            pointer-events: none;
            text-decoration: none;
          }
        }
      }
    }
  }
`

export const StyledDotSeparator = styled.div`
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-bottom: calc(0.5em - 3px);
  background-color: ${(props: ThemeProps) => props.theme.colors.gray400};
  border-radius: 50%;
`

export const StyledAvatarReviewer = styled.div`
  position: relative;
  img {
    border-radius: 50%;
  }
  .avatar {
    width: 40px;
    height: 40px;
    object-fit: cover;
  }
  .badge {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 16px;
    height: 16px;
  }
`
